// extracted by mini-css-extract-plugin
module.exports = {"orContainer":"Login_orContainer__3g_g2","or":"Login_or__1UwQY","orHr":"Login_orHr__3Gu1I","resetPassword":"Login_resetPassword__1LeLg","newAccount":"Login_newAccount__1H7CS"};